/**
 * This composable contains utility classes to scroll users to certain DOM elements within the page
 * and highlight them.
 */
export function useDomUtility() {
  const defaultOptions = {
    behaviour: 'smooth',
    inline: 'center',
    block: 'center',
  };

  function scrollToElement(elementId, options = defaultOptions) {
    const elementDocument = document.getElementById(elementId);
    if (elementDocument) {
      elementDocument.scrollIntoView(options);
    }
  }

  const scrollToProductInCanvas = function (product, options = defaultOptions) {
    const productTileId = `tile-product-${product.productKey}`;
    // Setting the first child, `tile-product-{pkey}` is a wrapper over the main tile element.
    // This is important to draw the blue border around the product image after search correctly.
    const productDocument = document.getElementById(productTileId).firstChild;

    // scroll user to where tile is
    productDocument.scrollIntoView(options);

    return productDocument;
  };

  function highlightElement(element) {
    // Sets an .active-search class to element and removes it after 1s.
    element.classList.add('active-search');
    setTimeout(() => {
      element.classList.remove('active-search');
    }, 1000);
  }

  const addActiveSearchBorderToProductElement = function (productElement) {
    // Sets an .active-search class to element and removes it after 1s.
    productElement.classList.add('active-search');
    setTimeout(() => {
      productElement.classList.remove('active-search');
    }, 1000);
  };

  return {
    addActiveSearchBorderToProductElement,
    highlightElement,
    scrollToElement,
    scrollToProductInCanvas,
  };
}
